import { Box, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface Props {
  /** Human-readable field name, e.g. "Registrations" */
  fieldLabel?: string;
}

/** Shown in place of a stage body when the field never reaches that stage */
const StageNotApplicable = ({ fieldLabel }: Props) => (
  <Box
    sx={{
      border: "1px solid #BDBDBD",
      borderRadius: "8px",
      backgroundColor: "#FAFAFA",
      p: 1,
    }}
  >
    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
      <InfoOutlinedIcon
        sx={{
          color: "#00000099",
          fontSize: 18,
        }}
      />

      <Typography
        sx={{
          color: "#00000099",
          fontSize: "14px",
          fontWeight: 500,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        Not Applicable
      </Typography>
    </Stack>

    <Typography
      sx={{
        color: "#00000099",
        fontSize: "14px",
        lineHeight: "20px",
      }}
    >
      <strong>{fieldLabel}</strong> is not applicable for this stage.
    </Typography>
  </Box>
);

export default StageNotApplicable;
